"use client"

import {useEffect, useRef} from "react"
import {staffSignedIn} from "@/components/analytics/page-view-beacon"

/**
 * Tells our API that a listing page was viewed, once per page view; the API
 * relays it to REALTOR.ca's analytics (rule 5(c)). It goes to the site's own
 * address with `credentials: "same-origin"`, so the API can set and read the
 * visitor-ID cookie `wch_lv`. Nothing is sent when a staff member is signed in
 * in this browser; errors are ignored.
 */
export function ListingViewBeacon({listingKey}: {listingKey: string}) {
    const sent = useRef<string | null>(null)

    useEffect(() => {
        if (sent.current === listingKey) return
        sent.current = listingKey
        if (staffSignedIn(document.cookie)) return
        try {
            fetch(`/api/v1/listings/${encodeURIComponent(listingKey)}/view`, {
                method: "POST",
                keepalive: true,
                credentials: "same-origin",
            }).catch(() => undefined)
        } catch {
            // A browser without fetch or keepalive: the view is not recorded.
        }
    }, [listingKey])

    return null
}
